<template>
  <div v-bind:class="eventTypeClass" class="home-event">
    <div class="event-like" @click="toggleLike">
      <i class="rds-icon rds-icon-stella" v-bind:class="{'like-color-press': userLike}"></i>
    </div>
    <div class="event-separator"></div>
    <div class="event-content" v-on:tap="goToEventPage">
      <div class="event-title">{{event.name}}</div>
      <div class="event-info">{{eventInfo}}</div>
    </div>
  </div>
</template>
<script>
import userService from '../services/User.service';
export default {
  name: 'home-event',
  props: ['event'],
  methods: {
    goToEventPage() {
      this.$router.push(`/eventi?day=${this.event.dateStart}`);
    },
    toggleLike() {
      const added = userService.toggleLike('events', this.event.id);
      console.log('added', added);

      if (added) {
        this.event.likes.push(userService.user.id);
      } else {
        this.event.likes.splice(
          this.event.likes.indexOf(userService.user.id),
          1
        );
      }
    }
  },
  computed: {
    eventInfo() {
      console.log(this.event);
      console.log(this.event.name);
      return `${this.eventDateString}, ${this.locationString}`;
    },
    userLike() {
      return this.event.likes.indexOf(userService.user.id) !== -1;
    },
    eventDateString() {
      let dateString;

      const start = new Date(this.event.dateStart);
      const end = new Date(this.event.dateEnd);

      if (start.getDate() !== end.getDate()) {
        let startString = start.getDate();
        if (start.getMonth() !== end.getMonth()) {
          startString = start.toLocaleString('it-it', {
            day: '2-digit',
            month: 'long'
          });
        }
        const endString = end.toLocaleString('it-it', {
          day: '2-digit',
          month: 'long'
        });
        dateString = `Dal ${startString} al ${endString}`;
      } else {
        dateString = end.toLocaleString('it-it', {
          day: '2-digit',
          month: 'long'
        });
      }

      return dateString;
    },
    locationString() {
      try {
        let locationArray = this.event.location.split(',');
        // const locationPlace = locationArray[0];
        const cityAndProvArr = locationArray[locationArray.length - 2].split(
          ' '
        );

        let locationCity = cityAndProvArr[cityAndProvArr.length - 2];
        return `${locationCity}`;
      } catch (error) {
        console.warn(error);

        return this.event.location;
      }
    },
    eventTypeClass() {
      // return `event-color-${this.event.color}`;
      return '';
    }
  }
};
</script>
<style lang="scss" scoped>
.home-event {
  // background-image: url("../assets/images/background-evento.svg");
  // background-size: contain;
  // background-repeat: no-repeat;
  // height: 103px;
  // padding: 0 15px;
  letter-spacing: 1px;
  position: relative;
  background-color: #ffffff;
  display: flex;
  margin: 10px 21px;
  padding: 14px 0;
  height: 60px;
  @include shadow-bottom;
  &::before {
    background-color: #f7f7f7;
    content: '';
    width: 25px;
    height: 25px;
    position: absolute;
    top: 50%;
    border-radius: 100%;
    transform: translate(-50%, -50%);
  }
  &::after {
    background-color: #f7f7f7;
    content: '';
    width: 25px;
    height: 25px;
    position: absolute;
    top: 50%;
    right: -24px;
    border-radius: 100%;
    transform: translate(-50%, -50%);
  }
  @each $label, $color in $calendar-colors {
    &.event-color-#{$label} .event-title {
      color: $color;
    }
  }
  .event-title {
    margin-bottom: 8px;
    font-size: 0.95em;
  }
  .event-info {
    font-size: 0.875em;
    color: #607d8b;
  }
  & > div {
    margin-top: auto;
    margin-bottom: auto;
  }
  .event-like {
    margin-left: 35px;
    // width: 13%;
    display: flex;
    // i {
    //   margin: auto;
    // }
  }
  .event-content {
    margin-right: 14px;
    // width: 87%;
  }
  .event-separator {
    margin: 0 25px;
    @include dotted-vertical;
    &:after {
      width: 2px;
      left: -2px;
    }
  }
}
</style>
